<template lang="pug">
  section
    ul.home__client-statuses
      li.home__client-status.client-status
        .client-status__wrapper
          span.client-status__title Всего клиентов:
          span.client-status__count {{ clients.length || "-" }}
      li.home__client-status.order-status
        .client-status__wrapper
          span.client-status__title Клиентов в этом месяце:
          span.client-status__count {{ thisMonthClientsCount || "-" }}
      li.home__client-status.order-status
        .client-status__wrapper
          span.client-status__title Клиентов с повторными заказами:
          span.client-status__count {{ clientsWithFewOrdersCount || "-" }}
    clients-list
    TutorialModal(ref="tutorial" title="Мои клиенты")
      .tut-modal__content   
        h2 Список всех клиентов
        p Если нужна подробная информация: нажмите на любое поле в строке, чтобы открыть описание клиента.
        p Эта страница удобна для поиска определенного клиента. Здесь вы можете отфильтровать таблицу по имени, адресу, количеству заказов или дате регистрации.
        p А еще здесь можно анализировать статистику по клиентам.
</template>

<style lang="scss" scoped>
@import '~@/assets/scss/core';

.home {
  &__client-statuses {
    @extend %ul-reset;
    font-weight: bold;
    margin-bottom: 24px;
  }
  &__client-status {
    display: block;
    max-width: 300px;
    margin-bottom: 8px;
  }
}
.client-status {
  &__wrapper {
    display: flex;
    justify-content: space-between;
  }

  &__title {
    flex-shrink: 0;
    max-width: 270px;
    width: 100%;
  }

  &__count {
    margin: 0 16px 0 0;
  }
}
</style>

<script>
import { mapState } from 'vuex';
import store from '@/store/store';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import ClientsList from '@/components/clients/ClientsList/ClientsList.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';

library.add(faEye);

export default {
  beforeRouteEnter(to, from, next) {
    const { id: firmId } = store.state.user.profile;
    store.commit('startLoad');
    store.dispatch('clientsGet', firmId).then(() => {
      store.commit('endLoad');
      next();
    });
  },

  beforeRouteUpdate(to, from, next) {
    const { id: firmId } = store.state.user.profile;
    this.$store.commit('startLoad');
    this.$store.dispatch('clientsGet', firmId).then(() => {
      this.$store.commit('endLoad');
      next();
    });
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id,
      clients: state => state.clients.clients
    }),

    thisMonthClientsCount() {
      return this.clients.filter(
        client =>
          new Date(client.created_at).getMonth() === new Date().getMonth()
      ).length;
    },

    clientsWithFewOrdersCount() {
      return this.clients.filter(client => client.orders_qty > 1).length;
    }
  },

  components: {
    FontAwesomeIcon,
    ClientsList,
    TutorialModal
  }
};
</script>
